import { HOST_QUERY_KEY } from '@kc-console/context';

import type { QueryClient } from '@tanstack/react-query';
import type {
  ServiceAppInitialState,
  ServiceAppRouteState,
  ServiceAppState,
} from '@kc-console/context';

interface UpdateGuardsStateParams {
  queryClient: QueryClient;
  state: Partial<ServiceAppState>;
}

/**
 * 이니셜 가드 결과를 쿼리키에 업데이트합니다.
 * @description
 * - state를 쿼리키에 저장하여 클라이언트 사이드에서 사용할 수 있도록 합니다.
 */
export const updateServiceAppInitialState = ({ state, queryClient }: UpdateGuardsStateParams) => {
  const {
    accessibleProjects,
    defaultProjectId,
    domainId,
    domainName,
    isProjectForced,
    isRegionForced,
    projectId,
    projectName,
    region,
    scope,
    token,
    userId,
    userName,
    bffEndpoint,
    env,
    iamEndpoint,
    iamSSREndpoint,
  } = state as ServiceAppState;

  const serviceAppInitialState: ServiceAppInitialState = {
    accessibleProjects,
    defaultProjectId,
    domainId,
    domainName,
    isProjectForced,
    isRegionForced,
    projectId,
    projectName,
    ...(region !== undefined ? { region } : {}),
    scope,
    token,
    userId,
    userName,
    bffEndpoint,
    env,
    iamEndpoint,
    iamSSREndpoint,
  };

  queryClient.setQueryData([HOST_QUERY_KEY.GET_SERVICE_APP_INITIAL_STATE], {
    ...serviceAppInitialState,
  });
};

/**
 * 라우트 가드 결과를 쿼리키에 업데이트합니다.
 * @description
 * - state를 쿼리키에 저장하여 클라이언트 사이드에서 사용할 수 있도록 합니다.
 */
export const updateServiceAppRouteState = ({ state, queryClient }: UpdateGuardsStateParams) => {
  const { status, language, displayLanguage } = state as ServiceAppState;

  const serviceAppRouteState: ServiceAppRouteState = { status, language, displayLanguage };

  queryClient.setQueryData([HOST_QUERY_KEY.GET_SERVICE_APP_ROUTE_STATE], serviceAppRouteState);
};
